import * as React from 'react'
import { useQuery, WatchQueryFetchPolicy } from '@apollo/client'
import * as Immutable from 'immutable'
import get from 'lodash/get'
import { Pagination } from './Pagination'

type Props = {
  query: any
  names: string[]
  variables?: Object
  EmptyView?: any
  infiniteScroll?: boolean
  renderItem: any
  repeat?: number
  fetchPolicy?: WatchQueryFetchPolicy
  notifyOnNetworkStatusChange?: boolean
  scrollableTarget?: string
}

export default function PaginationView({
  query,
  names,
  variables = {},
  EmptyView,
  infiniteScroll,
  renderItem,
  repeat = 1,
  fetchPolicy = null,
  notifyOnNetworkStatusChange = false,
  scrollableTarget = null,
}: Props) {
  const { data, error, loading, fetchMore } = useQuery(query, {
    variables,
    fetchPolicy,
    notifyOnNetworkStatusChange,
  })
  const { edges = [], pageInfo = {} } = get(data, names, {})

  const onLoadMore = React.useCallback(
    onLoadMoreCallback({ names, fetchMore, variables, pageInfo }),
    [fetchMore, pageInfo]
  )

  return (
    <Pagination
      {...{
        error,
        loading,
        edges,
        infiniteScroll,
        onLoadMore,
        pageInfo,
        repeat,
        renderItem,
        EmptyView,
      }}
    />
  )
}

export const onLoadMoreCallback = ({
  names,
  fetchMore,
  variables = {},
  pageInfo,
}) => {
  const newVariables = Immutable.fromJS(variables)
    .updateIn(['pageInput', 'cursor'], () => pageInfo.endCursor)
    .toJS()

  return () =>
    fetchMore({
      variables: newVariables,
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev

        return Immutable.fromJS(fetchMoreResult)
          .updateIn([...names, 'edges'], edges => [
            ...get(prev, names, {}).edges,
            ...edges,
          ])
          .toJS()
      },
    })
}
